import clsx from 'clsx';
import React from 'react';

import BaseButton from 'components/digifi-wrappers/Button';
import { ButtonProps } from 'product_modules/components/Button';

import styles from './Button.module.scss';

const Button = ({ className, ...props }: ButtonProps) => {
  return <BaseButton {...props} className={clsx(styles.button, className)} />;
};

export default Button;
